import { render, staticRenderFns } from "./PartyBuilding.vue?vue&type=template&id=4e37a80a&scoped=true&"
import script from "./PartyBuilding.vue?vue&type=script&lang=js&"
export * from "./PartyBuilding.vue?vue&type=script&lang=js&"
import style0 from "./PartyBuilding.vue?vue&type=style&index=0&id=4e37a80a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e37a80a",
  null
  
)

export default component.exports